/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Download_FailedInputs */

const en_shop_download_failed = /** @type {(inputs: Shop_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start the download. Try again.`)
};

const pl_shop_download_failed = /** @type {(inputs: Shop_Download_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się rozpocząć pobierania. Spróbuj ponownie.`)
};

/**
* | output |
* | --- |
* | "Could not start the download. Try again." |
*
* @param {Shop_Download_FailedInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_download_failed = /** @type {((inputs?: Shop_Download_FailedInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Download_FailedInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_download_failed(inputs)
	return en_shop_download_failed(inputs)
});